import { render, staticRenderFns } from "./ProductSizeGuideModal.vue?vue&type=template&id=2031117c&lang=pug&"
import script from "./ProductSizeGuideModal.vue?vue&type=script&lang=js&"
export * from "./ProductSizeGuideModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizeGuideModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports